import React from "react";
import "./Banner.css";
import imageData from "../../Images/OBJECTS.png";

const Bannerpage = () => {
  return (
    <div className="banner-content-data">
      <div className="left-container md:basis-2/3">
        <h1 className="leading-tight ">
          Build Smarter, Scale Faster AI-Powered Software at Your Fingertips
        </h1>
        <p className="!my-5">
          AI-powered dev team building high-performance digital solutions. Fast. Smart.
          Disruptive.{" "}
        </p>
        <button
          onClick={() => {
            window.location.href = "https://calendly.com/owision";
          }}
        >
          <span style={{ zIndex: "2222", position: "relative" }}>Schedule Free Consultations</span>
          <div className="hover-color"></div>
        </button>
      </div>
      <div className="right-contanier md:basis-1/3 ">
        <img src={imageData} alt="" />
      </div>
    </div>
  );
};

export default Bannerpage;
